import { Currency } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'
import useHttpLocations from 'hooks/useHttpLocations'
import { useMemo } from 'react'
import { WrappedTokenInfo } from 'state/lists/wrappedTokenInfo'

import SolanaLogo from '../../assets/svg/sol.svg'

type Network = 'ethereum' | 'arbitrum' | 'optimism' | 'solana'

function chainIdToNetworkName(networkId: SupportedChainId): Network {
  switch (networkId) {
    case SupportedChainId.SOLANA_MAINNET:
    case SupportedChainId.SOLANA_TESTNET:
    case SupportedChainId.SOLANA_DEVNET:
    default:
      return 'solana'
  }
}

function getNativeLogoURI(chainId: SupportedChainId = SupportedChainId.SOLANA_MAINNET): string {
  switch (chainId) {
    case SupportedChainId.SOLANA_MAINNET:
    case SupportedChainId.SOLANA_TESTNET:
    case SupportedChainId.SOLANA_DEVNET:
      return SolanaLogo
    default:
      return SolanaLogo
  }
}

function getTokenLogoURI(address: string, chainId: SupportedChainId = SupportedChainId.SOLANA_MAINNET): string | void {
  const networkName = chainIdToNetworkName(chainId)
  const networksWithUrls = [-1]
  //Feature CHAIN [SupportedChainId.ARBITRUM_ONE, SupportedChainId.MAINNET, SupportedChainId.OPTIMISM]
  if (networksWithUrls.includes(chainId)) {
    return `https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/${networkName}/assets/${address}/logo.png`
  }
}

export default function useCurrencyLogoURIs(currency?: Currency | null): string[] {
  const locations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken) {
        const logoURI = getTokenLogoURI(currency.address, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
